<template>
  <div>
    <titleSeeting :active="active" class="setting" />
    <div>
      <!--实验分组-->
      <div class="first">
        <div class="title"><span class="circle" />试验分组</div>
        <div class="detail">
          <el-row style="text-align: right; margin-bottom: 5px">
            <el-button
              v-if="isSample"
              size="mini"
              type="primary"
              @click="createPerNum"
              >生成入组人数
            </el-button>
          </el-row>
          <el-row>
            <el-col :span="24" style="border: 1px solid #e5eeff">
              <el-table
                ref="tb"
                size="mini"
                :data="testData"
                style="width: 100%"
                :row-class-name="rowClassName"
                :header-cell-style="headeCellStyle"
              >
                <!--<el-table-column label="序号" align="center" prop="xh" width="50" />-->
                <el-table-column prop="code" label="试验组号" width="200">
                  <template slot-scope="scope">
                    <el-input
                      v-model="testData[scope.row.xh - 1].code"
                      size="mini"
                      placeholder=""
                      :disabled="isLock"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="试验组名" width="500">
                  <template slot-scope="scope">
                    <el-input
                      v-model="testData[scope.row.xh - 1].name"
                      size="mini"
                      placeholder=""
                      :disabled="isLock"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="ratio" label="分组比例" width="157">
                  <template slot-scope="scope">
                    <el-input
                      v-model="testData[scope.row.xh - 1].ratio"
                      size="mini"
                      placeholder=""
                      type="number"
                      :disabled="isLock"
                      @mousewheel.native.prevent
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isSample"
                  prop="num"
                  label="入组人数"
                  width="155"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="testData[scope.row.xh - 1].num"
                      size="mini"
                      placeholder=""
                      :disabled="disableGroup"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="!is_use_blind"
                  prop="btn"
                  label=""
                  style="border: 1px solid red"
                >
                  <template slot-scope="scope">
                    <div>
                      <img
                        src="../../assets/avatar/add.png"
                        alt="增加"
                        width="20px"
                        style="margin-right: 10px"
                        @click="add"
                      />
                      <img
                        src="../../assets/avatar/reduce.png"
                        alt="增加"
                        width="20px"
                        @click="handleReduce(scope.row)"
                      />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <div class="word">分组比例请填写最简比例</div>
            <!--<el-col :span="4" class="icon">-->
            <!--<img src="../../assets/avatar/add.png" alt="增加" width="20px" style="margin-right: 10px;" @click="add">-->
            <!--<img src="../../assets/avatar/reduce.png" alt="增加" width="20px" @click="handleReduce(index)">-->
            <!--</el-col>-->
          </el-row>
        </div>
        <!--中心与分层设置-->
      </div>
      <!--中心与分层-->
      <div class="two">
        <div class="title"><span class="circle" />中心与分层设置</div>
        <div class="detail">
          <!--中心设置-->
          <div>
            <el-row>
              <el-col :span="2"><span class="circle" />中心分层</el-col>
              <el-col :span="20">
                <el-row>
                  <el-col :span="4" style="text-align: right"
                    >是否需要中心分层：
                  </el-col>
                  <el-col :span="18">
                    <el-radio-group
                      v-model="is_need_blind_unit"
                      :disabled="isLock"
                      @change="handleIsBlind"
                    >
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <div v-if="isBlind">
              <el-row class="" style="padding: 15px 0">
                <el-col :span="8" style="border: 1px solid #fff">
                  <el-row v-if="isContend">
                    <el-col v-if="isDistribute" :span="6" class="rights">
                      <span
                        class="circle"
                        style="background-color: #fff"
                      />中心权重：
                    </el-col>
                    <el-col v-if="isDistribute" :span="12">
                      <el-input
                        v-model="unit_weight"
                        size="mini"
                        type="text"
                        :disabled="isLock || is_use_blind"
                      />
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <div style="border: 1px solid #e5eeff">
                <el-table
                  size="mini"
                  :data="centerData"
                  style="width: 100%"
                  :header-cell-style="headeCellStyle"
                  :cell-style="{ 'text-align': 'center' }"
                >
                  <el-table-column prop="code" width="200" label="中心编号" />
                  <el-table-column prop="name" label="中心名称" width="500" />
                  <el-table-column
                    prop="num"
                    label="受试者人数限制"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.num"
                        size="mini"
                        :disabled="is_num_lock"
                        type="number"
                        @mousewheel.native.prevent
                      />
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!--分层设置-->
          <div class="item">
            <el-row>
              <el-col :span="2"><span class="circle" />分层设置</el-col>
              <el-col :span="20">
                <el-row>
                  <el-col :span="4" style="text-align: right"
                    >是否需要分层设置：
                  </el-col>
                  <el-col :span="18">
                    <el-radio-group
                      v-model="is_need_layer"
                      :disabled="isLock"
                      @change="handleIsLayer"
                    >
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-table
              size="mini"
              :data="layerData"
              style="width: 100%"
              :row-class-name="rowClassName"
              highlight-current-row
              :header-cell-style="headeCellStyle"
            >
              <el-table-column prop="">
                <template slot-scope="scope">
                  <div v-if="isLayer">
                    <el-row class="" style="padding: 15px 0">
                      <el-col :span="8">
                        <el-col
                          :span="10"
                          class="rights"
                          style="text-align: center"
                        >
                          <span
                            class="circle"
                            style="background-color: #fff"
                          />分层名称：
                        </el-col>
                        <el-col :span="12">
                          <el-input
                            v-model="scope.row.name"
                            size="mini"
                            type="text"
                            :disabled="isLock"
                          />
                        </el-col>
                      </el-col>
                      <el-col :span="6" v-if="isContend">
                        <el-row v-if="isDistribute">
                          <el-col :span="6" class="rights">
                            <span class="circle" />分层权重：
                          </el-col>
                          <el-col :span="12">
                            <el-input
                              v-model="scope.row.weight"
                              size="mini"
                              type="number"
                              :disabled="isLock"
                            />
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="6">
                        <el-row v-if="projectDetail.is_synchro_edc">
                          <el-col
                            :span="10"
                            class="rights"
                            style="text-align: center"
                          >
                            <span class="circle" />变量匹配：
                          </el-col>
                          <el-col :span="12">
                            <el-select
                              :disabled="isLock"
                              v-model="scope.row.layer_edc_name"
                              clearable
                              placeholder=""
                              size="mini"
                            >
                              <el-option
                                v-for="(item, index) in inputNameList"
                                :key="index"
                                :label="item"
                                :value="item"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col
                        v-if="!is_use_blind"
                        :span="4"
                        style="text-align: right"
                      >
                        <img
                          src="../../assets/avatar/add.png"
                          alt=""
                          width="20px"
                          style="margin-right: 10px"
                          @click="addItem"
                        />
                        <img
                          src="../../assets/avatar/reduce.png"
                          alt=""
                          width="20px"
                          @click="delItem(scope.row)"
                        />
                      </el-col>
                    </el-row>
                    <div style="border: 1px solid #e5eeff">
                      <el-table
                        size="mini"
                        :data="scope.row.item_list"
                        style="width: 100%"
                        :row-class-name="rowClassName"
                        :header-cell-style="headeCellStyle"
                      >
                        <el-table-column prop="code" label="层编号" width="200">
                          <template slot-scope="scopeList">
                            <el-input
                              v-model="scopeList.row.code"
                              size="mini"
                              placeholder=""
                              type="text"
                              :disabled="isLock"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="name"
                          label="层因子名称"
                          width="500"
                        >
                          <template slot-scope="scopeList">
                            <el-input
                              v-model="scopeList.row.name"
                              size="mini"
                              placeholder=""
                              type="text"
                              :disabled="isLock"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="num"
                          label="受试者人数限制"
                          width="200"
                        >
                          <template slot-scope="scopeList">
                            <el-input
                              v-model="scopeList.row.num"
                              size="mini"
                              placeholder=""
                              :disabled="isLock && is_num_lock"
                              type="number"
                              @mousewheel.native.prevent
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          v-if="!is_use_blind"
                          prop="btn"
                          label=""
                          style="border: 1px solid red"
                        >
                          <template slot-scope="scopeList">
                            <div>
                              <img
                                src="../../assets/avatar/add.png"
                                alt="增加"
                                width="20px"
                                style="margin-right: 10px"
                                @click="addLayer(scope.row)"
                              />
                              <img
                                src="../../assets/avatar/reduce.png"
                                alt="增加"
                                width="20px"
                                @click="
                                  handleReduceLayer(scope.row, scopeList.row)
                                "
                              />
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--组合层-->
          <div v-if="isDistribute" class="item">
            <div v-if="isDynamic">
              <el-row>
                <el-col :span="2"><span class="circle" />组合层设置</el-col>
                <el-col :span="12">
                  <el-row>
                    <el-col :span="8" style="text-align: right"
                      >是否需要组合层设置：
                    </el-col>
                    <el-col :span="16">
                      <el-radio-group
                        v-model="is_need_combination_layer"
                        :disabled="isLock"
                        @change="handleCom"
                      >
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col v-if="isCom" :span="10" style="text-align: right">
                  <el-button
                    :disabled="isLock"
                    size="mini"
                    type="primary"
                    @click="submit"
                    >生成
                  </el-button>
                </el-col>
              </el-row>
              <div
                v-if="isCom"
                style="border: 1px solid #e5eeff; margin-top: 10px"
              >
                <el-table
                  size="mini"
                  :data="combinationData"
                  style="width: 100%"
                  :header-cell-style="headeCellStyle"
                >
                  <el-table-column prop="code" label="组合层编号" width="200" />
                  <el-table-column prop="desc" label="组合层描述" width="500" />
                  <el-table-column
                    prop="group_method"
                    label="入组方法"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.group_method"
                        placeholder="请选择"
                        size="mini"
                        :disabled="isLock"
                      >
                        <el-option
                          v-for="(item, d) in groupList"
                          :key="d"
                          :label="item.name"
                          :value="item.name"
                        />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="受试者人数限制"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.num"
                        size="mini"
                        type="number"
                        @mousewheel.native.prevent
                        :disabled="isLock && is_num_lock"
                      />
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--操作区-->
    <el-row class="btn">
      <el-button size="mini" type="primary" style="width: 100px" @click="goBack"
        >上一步
      </el-button>
      <el-button
        v-preventReClick
        size="mini"
        style="width: 100px"
        type="primary"
        @click="goNext"
        >下一步
      </el-button>
    </el-row>
  </div>
</template>

<script>
import titleSeeting from "./component/titleSeeting";
import { researchAll } from "@/api/company";
import { getLayer, detailData, getEDCInputName } from "@/api/random";
import { detailPro } from "@/api/platform";
import { getProjectId } from "@/utils/auth";

export default {
  name: "Parameter",
  components: {
    titleSeeting,
  },
  data() {
    return {
      headeCellStyle: {
        textAlign: "center",
      },
      headerCellClassCame: "headerCellClassCame",
      rowClassName({ row, rowIndex }) {
        row.xh = rowIndex + 1;
      },
      active: 2,
      proId: "",
      num: null,
      // 试验分组
      testData: [
        {
          code: "",
          name: "",
          ratio: "",
          num: "",
          btn: null,
        },
        {
          code: "",
          name: "",
          ratio: "",
          num: "",
          btn: null,
        },
      ],
      is_num_lock: false, //受试者人数限制只有项目锁定才禁用
      is_need_blind_unit: true, // 是否需要中心设置
      unit_weight: "", // 中心权重
      is_need_layer: true, // 是否需要分层设置
      layerData: [
        {
          name: "", //
          weight: null,
          item_list: [{}, {}],
        },
      ],
      centerData: [], // 中心设置
      groupList: [
        { name: "竞争入组" },
        { name: "分配入组" },
        { name: "先分配后竞争入组" },
      ],
      is_need_combination_layer: true,
      combinationData: [
        // {
        //   code: '',
        //   num: null,
        //   desc: '',
        //   group_method: '竞争入组'
        // }
      ], // 组合层数据
      group_method: "", // 入组方法
      type: "", // 类型区分
      dynamicType: "", // 动静态
      isContend: true, // 竞争区段
      isDistribute: true, // 分配
      isDynamic: true, // 动态随机
      isBlind: true,
      isLayer: true,
      isCom: true,
      sample_size: null, // 样本量
      unit_id: "", // 中心Id
      disableGroup: false,
      isSample: true,
      centerUnitData: [], // 中心
      isLock: false, // 锁定项目不可编辑
      is_use_blind: false, // 是否锁定
      inputNameList: [],
      projectDetail: {},
    };
  },
  async created() {
    this.proId = getProjectId();
    this.type = this.$route.query.section_type; // 竞争和分配
    this.sample_size = Number.parseInt(this.$route.query.sample_size);
    if (this.sample_size) {
      this.disableGroup = true;
    } else if (!this.sample_size || this.sample_size === 0) {
      this.isSample = false;
    }
    this.dynamicType = sessionStorage.getItem('Random') // 动态和静态区分
    if (this.type === "竞争区段") {
      this.isContend = false;
    } else if (this.type === "分配区段") {
      this.isDistribute = false;
    } else if (this.dynamicType === "动态随机") {
      this.isDynamic = false;
    }
    await this.detailPro();
    this.createPerNum();
    this.getInputNameList();
  },
  methods: {
    getInputNameList() {
      getEDCInputName({
        project_id: this.proId,
      }).then((res) => {
        this.inputNameList = res.data;
      });
    },
    createPerNum() {
      if (!this.sample_size) {
        return false;
      }
      const nameFlag = this.testData.some((item) => !item.name);
      if (nameFlag) {
        // this.$message({
        //   message: "请输入试验组号",
        //   type: "warning",
        // });
        return false;
      }
      const codeFlag = this.testData.some((item) => !item.code);
      if (codeFlag) {
        // this.$message({
        //   message: "请输入试验组号",
        //   type: "warning",
        // });
        return false;
      }
      const ratioFlag = this.testData.some((item) => !item.ratio);
      if (ratioFlag) {
        // this.$message({
        //   message: "请输入试验组号",
        //   type: "warning",
        // });
        return false;
      }

      const num = this.testData.reduce((pre, cur) => {
        return pre + Number.parseInt(cur.ratio);
      }, 0);
      const div = Number.parseInt(this.sample_size) / Number.parseInt(num);
      const list = this.testData.map((item) => {
        const obj = item;
        obj.num = Number.parseInt(item.ratio) * Number.parseInt(div);
        return obj;
      });
      this.testData = list;
    },
    detailPro() {
      return detailPro({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            this.projectDetail = res.data;
            if (res.data.section_type === "竞争区段") {
              this.isContend = false;
            }
            //受试者人数限制只有项目锁定才禁用
            if (res.data.status === "项目已锁定") {
              this.is_num_lock = true;
            }
            // this.is_use_blind = res.data.is_use_blind;
            if (res.data.status  !== "项目创建中") {
              this.isLock = true;
            } else {
              this.isLock = false;
            }
            this.is_need_layer = res.data.is_need_layer;
            this.is_need_combination_layer = res.data.is_need_combination_layer;
            this.is_need_blind_unit = res.data.is_need_blind_unit;
            if (!res.data.is_need_blind_unit) {
              this.isBlind = false;
            }
            if (!this.is_need_layer) {
              this.isLayer = false;
            } else {
              this.isLayer = true;
            }
            if (!this.is_need_combination_layer) {
              this.isCom = false;
            }
            if (res.data.group_list && res.data.group_list.length > 0) {
              this.testData = res.data.group_list.map((item) => {
                if (item.num === 0) {
                  item.num = "";
                  return item;
                } else {
                  return item;
                }
              });
            }
            console.log("dnksdw");
            console.log(this.testData);
            this.centerUnitData = res.data.blind_unit_list;
            this.centerData = res.data.blind_unit_list.map((item) => {
              if (item.num === 0) {
                item.num = "";
                return item;
              } else {
                return item;
              }
            });
            // this.centerData = res.data.blind_unit_list // 一键导入后中心数据展示
            if (this.centerUnitData.length > 0) {
              this.disabledCenter = true;
            }
            if (res.data.layer_list && res.data.layer_list.length > 0) {
              this.layerData = res.data.layer_list.map((item) => {
                const arr = item.item_list.map((items) => {
                  if (items.num === 0) {
                    items.num = "";
                  }
                  return items;
                });
                item.item_list = arr;
                return item;
              });
            }
            this.combinationData = res.data.combination_layer_list;
            if (res.data.unit_weight === 0) {
              this.this.unit_weight = "";
            } else {
              this.unit_weight = res.data.unit_weight;
            }
            // })
            // // this.centerData = res.data.blind_unit_list // 一键导入后中心数据展示

            // if (res.data.layer_list && res.data.layer_list.length > 0) {
            //   this.layerData = res.data.layer_list.map(item => {
            //     const arr = item.item_list.map(items => {
            //       items.num = ''
            //       return items
            //     })
            //     item.item_list = arr
            //     return item
            //   })
            // }
            // this.combinationData = res.data.combination_layer_list
            // if (res.data.unit_weight === 0) {
            //   this.this.unit_weight = ''
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    addItem() {
      const obj = {};
      obj.name = "";
      obj.item_list = [{}, {}];
      this.layerData.push(obj);
    },
    delItem(row) {
      if (this.layerData.length <= 1) {
        return false;
      }
      this.layerData.splice(row.xh - 1, 1);
    },
    handleIsBlind(val) {
      if (val) {
        this.isBlind = true;
      } else {
        this.isBlind = false;
      }
    },
    handleIsLayer(val) {
      if (val) {
        this.isLayer = true;
      } else {
        this.isLayer = false;
      }
    },
    handleCom(val) {
      if (val) {
        this.isCom = true;
      } else {
        this.isCom = false;
      }
    },
    // 试验分组
    add() {
      if (this.testData === undefined) {
        this.testData = [];
      }
      const obj = {};
      obj.code = "";
      obj.name = "";
      obj.ratio = "";
      obj.num = "";
      this.testData.push(obj);
    },
    handleReduce(row) {
      if (this.testData.length <= 1) {
        return false;
      }
      this.testData.splice(row.xh - 1, 1);
    },
    addLayer(row) {
      this.layerData[row.xh - 1].item_list.push({});
    },
    handleReduceLayer(row, rowList) {
      if (this.layerData[row.xh - 1].item_list.length <= 1) {
        return false;
      }
      this.layerData[row.xh - 1].item_list.splice(rowList.xh - 1, 1);
    },
    submit() {
      const obj = {};
      obj.id = this.proId;
      obj.layer_list = this.layerData;
      console.log(obj);
      getLayer(obj)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.combinationData = res.data;
              this.layerData = res.layer_list;
            } else {
              this.combinationData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    goBack() {
      this.$router.push({
        path: "/random/index",
      });
    },
    goRandomdatas() {
        this.$router.push({
          path: "/random/datas",
          query: {
            random_type: this.$route.query.random_type,
            section_type: this.$route.query.section_type,
            sample_size: this.$route.query.sample_size,
          },
        });
    },
    goNext() {
      if (this.is_num_lock) {
        this.goRandomdatas();
        return;
      }
      console.log(this.testData);
      this.testData.map((item) => {
        const obj = {};
        obj.id = item.id;
        obj.code = item.code;
        obj.name = item.name;
        obj.ratio = item.ratio;
        obj.num = item.num;
        return obj;
      });
      console.log(this.centerData);
      const centerData = this.centerData.map((item) => {
        // console.log(item);
        const obj = {};
        if (this.centerUnitData && this.centerUnitData.length > 0) {
          // console.log("编辑");
          obj.id = item.id;
        } else {
          // console.log("新增");
          obj.unit_id = item.id;
        }
        // console.log("fd能承受的");
        // console.log(item);
        obj.num = item.num = item.num ? item.num : "";
        return obj;
      });
      // console.log(centerData);
      const layerData = this.layerData.map((item) => {
        const obj = {};
        obj.id = item.id;
        obj.name = item.name;
        obj.weight = item.weight;
        obj.layer_edc_name = item.layer_edc_name;
        const list = item.item_list;
        const listdata = [];
        list.map((i) => {
          const a = {};
          a.id = i.id;
          a.name = i.name;
          a.code = i.code;
          a.num = i.num;
          listdata.push(a);
          console.log(listdata);
        });
        obj.item_list = listdata;
        return obj;
      });

      // bug修改 判断每条入组方法是否选择了
      // console.log('this.combinationData', this.combinationData)
      if (
        this.is_need_combination_layer === true && this.$route.query.section_type==="竞争区段"&&!this.combinationData.every((item) => item.group_method)
      ) {
        this.$message.warning("请先选择入组方法");
      } else {
        const combinationData = this.combinationData.map((item) => {
          const obj = {};
          obj.id = item.id;
          obj.code = item.code;
          obj.num = item.num;
          obj.group_method = item.group_method;
          return obj;
        });
        const params = {
          id: this.proId,
          group_list: this.testData,
          is_need_blind_unit: this.is_need_blind_unit,
          blind_unit_list: centerData,
          unit_weight: this.unit_weight,
          is_need_layer: this.is_need_layer,
          layer_list: layerData,
          is_need_combination_layer: this.is_need_combination_layer,
          combination_layer_list: combinationData,
        };
        // if (!this.isLock) {
        detailData(params)
          .then((res) => {
            if (res && res.code === 0) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.goRandomdatas();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((res) => {
            console.log(res.msg);
          });
      }
    },
  },
};
</script>

<style scoped>
.setting {
  margin-bottom: 30px;
}

.title {
  font-size: 16px;
  color: #595959;
  font-weight: 500;
  margin-bottom: 10px;
}

.item {
  margin: 20px 0 10px 0;
}

.detail {
  margin: 0 30px;
}

.right {
  text-align: right;
  line-height: 26px;
}

.circle {
  width: 8px;
  height: 8px;
  background-color: #8eb1ff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.first {
  padding-bottom: 20px;
  border-bottom: 1px dashed #bfbfbf;
}

.two {
  margin-top: 20px;
}

.rights {
  line-height: 26px;
}

.btn {
  margin: 30px;
  text-align: center;
}

.word {
  font-size: 12px;
}
</style>
<style>
table {
  border-collapse: collapse;
}

.templateColumn {
  border-right: 1px solid #aaa;
}

table.templateContainer > table:nth-child(3n) {
  border: none;
}

.columnsContainer:last-of-type .templateColumn {
  border-right: 0px;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
